// extracted by mini-css-extract-plugin
export var root = "Tournaments-module--root--iksl+";
export var title = "Tournaments-module--title--pht+Q";